<circ-loader [isLoading]="loading">
  <h2>{{ 'step_details_legend' | i18n }}</h2>
  <div *ngIf="providerComponent">
    <ng-container *ngComponentOutlet="providerComponent"></ng-container>
  </div>
</circ-loader>
